var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearSort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M2.692 0c.24 0 .433.194.433.433v12.013l1.52-1.521a.433.433 0 1 1 .613.612l-2.26 2.26a.432.432 0 0 1-.612 0l-2.26-2.26a.433.433 0 1 1 .613-.612l1.52 1.521V.433c0-.239.195-.433.433-.433zm13.053 5.046a4.077 4.077 0 0 1 4.073 4.072 4.077 4.077 0 0 1-4.073 4.073 4.077 4.077 0 0 1-4.072-4.073 4.076 4.076 0 0 1 4.072-4.072zm0 .666a3.41 3.41 0 0 0-3.405 3.406 3.41 3.41 0 0 0 3.405 3.406 3.41 3.41 0 0 0 3.406-3.406 3.41 3.41 0 0 0-3.406-3.406zm1.407 1.291l.613.612-1.503 1.503 1.503 1.503-.613.613-1.503-1.503-1.503 1.503-.613-.613 1.503-1.503-1.503-1.503.613-.612 1.503 1.503 1.503-1.503zm-6.507 1.3V10.3H5.94V8.304h4.705zm3.417-4.008v.45a4.689 4.689 0 0 0-2.045 1.545H5.94V4.295h8.123zM18.33.285V2.28H5.939V.286h12.39z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4 7)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#7B26C9",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4-7h28v28H-4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearSort);
export default __webpack_public_path__ + "static/media/clear-sort.735aa1ceffc42824e9bf1e654f872161.svg";
export { ForwardRef as ReactComponent };